import { shallowRef, computed, unref } from "vue";
const unrefElement = (el) => {
  const e = unref(el);
  return (e == null ? void 0 : e.$el) ?? e;
};
const useElementRef = () => {
  const el = shallowRef();
  return computed({
    get() {
      return unrefElement(el);
    },
    set(node) {
      el.value = node;
    }
  });
};
export {
  useElementRef as u
};
//# sourceMappingURL=useElementRef-6a3a78f2.mjs.map
